module.exports = __webpack_public_path__ + "img/point2.42326496.jpg";